export const commonResources = {
  'common.logout': 'Se déconnecter',
};
export type CommonResourceKey = 'common.logout';
